import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
import axios from 'axios';

export const updateFormEditorFormService = async (fullModifiedItem) => {
  const apiPath = 'form-editor';

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'PUT',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(fullModifiedItem),
    data: fullModifiedItem,
  };

  const signedRequest = await createSignedRequest(request);

  const res = await axios(signedRequest);

  return res.data;
};
